import {useLocation} from 'react-router-dom';
import 'url-search-params-polyfill';

function useQuery(): URLSearchParams {
  return new URLSearchParams(useLocation().search);
}

export default useQuery;
